import { getToken } from '@/libs/util.token'

export default ({ request }) => ({
  pendingGoodsWorkLogListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/work/log/pageList',
      method: 'post',
      data,
    })
  },
  pendingGoodsWorkLogDetailApi(pendingGoodsWorklogCode) {
    return request({
      url: `/factory/mrp/pending/goods/work/log/${pendingGoodsWorklogCode}`,
      method: 'GET',
    })
  },
  sysUserWorkShopApi(data = {}) {
    return request({
      url: '/sys/user/workshop/list',
      method: 'post',
      data,
    })
  },
  pendingGoodsWorkLogWithExcelImportApi({ file, confirmSaved = false } = {}) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('confirmSaved', confirmSaved)

    return request({
      url: '/factory/mrp/pending/goods/work/log/withExcelImport',
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      data: formData,
      timeout: 60 * 1000,
    })
  },
  pendingGoodsWorkLogSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/work/log/save',
      method: 'post',
      data,
    })
  },
  pendingGoodsWorkLogChangeGoodsApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/work/log/changeGoods',
      method: 'post',
      data,
    })
  },
  pendingGoodsWorkLogBatchSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/work/log/batch/submit',
      method: 'post',
      data,
    })
  },
})
